module.exports = __webpack_public_path__ + "static/media/logo.c66f8655.png";